// extracted by mini-css-extract-plugin
export var carrierIcon = "_xb-0";
export var carrierLogo = "_xb-1";
export var detailsSection = "_xb-2";